import { studentGateway } from '../student-gateway';

import { IBadge } from '@features/dashboard/types';

const getBadges = async (programmeId?: number): Promise<IBadge[]> => {
    try {
        const response = await studentGateway.get('/badges', {
            params: { programme_id: programmeId },
        });
        return response.data;
    } catch (error) {
        throw new Error('Something went wrong loading your badges.');
    }
};

const postBadge = async (code: string, programmeId?: number): Promise<any> => {
    try {
        const response = await studentGateway.post(
            `/badges/${code}/claim`,
            null,
            {
                params: {
                    code: code,
                    programme_id: programmeId,
                },
            },
        );
        return response.data;
    } catch (error) {
        throw new Error('Something went wrong claiming your badge.');
    }
};

export { getBadges, postBadge };
